import React from "react";
import {
  Drawer,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import DrawerHeader, { DRAWER_NO_SLIDE, DRAWER_PAPER_PROPS } from "./DrawerHeader";

const PHPDrawer = ({ open, obsoletePHP, handleCloseDrawer, role }) => {
  const theme = useTheme();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleCloseDrawer}
      PaperProps={DRAWER_PAPER_PROPS.compact}
      SlideProps={DRAWER_NO_SLIDE}
      // Sans ça, le scroll lock de MUI pose overflow:hidden + padding-right sur
      // <body> à l'ouverture, ce qui relayoute tout le dashboard pendant l'animation.
      disableScrollLock
    >
      <div>
        <DrawerHeader
          title="Versions PHP obsolètes"
          subtitle={`Total : ${obsoletePHP.length} site${obsoletePHP.length > 1 ? "s" : ""}`}
          onClose={handleCloseDrawer}
          role={role}
        />

        {/* Contenu du drawer (tableau) */}
        <div className="drawerTab">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Site</TableCell>
                  <TableCell align="center">Version PHP</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {obsoletePHP.map((site, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0
                        ? theme.palette.background.alternate
                        : theme.palette.background.paper,
                    }}
                  >
                    <TableCell align="left">
                      {site.content.name} ({site.content.environnement})
                    </TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                      {site.content.php_version}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </Drawer>
  );
};

export default PHPDrawer;
